import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import exportExcelApi from 'api/invoice/exportExcelApi';

export const fetchExportExcel = createAsyncThunk(
    'exportExcel/fetch_exportExcel_detail',
    async (dataQuery, thunkParams) => {
        let result;
        switch (dataQuery.exportSource) {
            case "fast":
                result = exportExcelApi.exportFastCA(dataQuery.search)
                break;
            case "misa":
                result = exportExcelApi.exportMISA(dataQuery.search);
                break;
            case "smart":
                result = exportExcelApi.exportSMART(dataQuery.search);
                break;
            case "bangke0":
                result = exportExcelApi.exportBANGKE(dataQuery.search);
                break;
            case "bangkehd":
                result = exportExcelApi.exportBANGKEHOADON(dataQuery.search);
                break;
            case "bangkehh":
                result = exportExcelApi.exportBANGKEHANGHOA(dataQuery.search);
                break;
            case "ncc":
                result = exportExcelApi.exportNCC(dataQuery.search);
                break;
            case "hanghoa":
                result = exportExcelApi.exportHangHoa();
                break;
            default:
                result = null;
                break;
        }
        return result
    }
)
const initialState = {
    b64Excel: '',
    loading: 'idle',
    error: null
}
export const exportExcelSlice = createSlice({
    name: 'exportExcel',
    initialState,
    reducers: {
        setB64Excel: (state, action) => {
            state.b64Excel = action.payload;
        },
        // standard reducer logic, with auto-generated action types per reducer
    },
    extraReducers: (builder) => {
        // Add reducers for additional action types here, and handle loading state as needed
        //   builder.addCase(fetchExportExcel.fulfilled, (state, action) => {
        //     // Add user to the state array
        //     state.entities.push(action.payload)
        //   })
    },
})


export const { setB64Excel } = exportExcelSlice.actions;

export const selectB64Excel = (state) => state?.exportExcel?.b64Excel;
export default exportExcelSlice.reducer;

